<div
  class="info-box"
>
  <i
    class="fa-regular {{ icon }} icon-regular"
  ></i>
  <div class="info-text">
    <div class='info-title'>{{ title }}</div>
    <div class='info-description'>{{ description }}</div>
  </div>
</div>
